
import React,{useState,useEffect} from "react"
import Editor from "./Editor"


function App() {
  const [html,setHtml] =useState('');
  const [css,setCss] =useState('');
  const [js,setJs] =useState('');
  const [srcDoc,setSrcdoc] = useState('')

  useEffect(()=>{
    const timeout = setTimeout(()=>{
      setSrcdoc(
        `
  <html>
<body>${html}
</body>
<style>${css}</style>
<script>${js}</script>
  </html>
  `
      )

    },250)
    return  () => clearTimeout(timeout)

  },[html,css,js])

  return (
    <>
    <div className="pane top-pane">
      <Editor language="xml" displayname="HTML" value={html} onChange={setHtml} />
      <Editor language="css" displayname="CSS" value={css} onChange={setCss} />
      <Editor  language="javascript" displayname="Js" value={js} onChange={setJs}/>

    </div>
    <div className="pane ">
      <iframe title="output" sandbox="allow-scripts" frameBorder="0" width="100%" height="100%" srcDoc={srcDoc} />

    </div>
    </>
  );
}

export default App;
